<template>
  <div class="local-retail local-retail__input--price">
    <AppHeading theme="black" element="h2" size="xs" spacing="md">
      {{ title }}
    </AppHeading>

    <div class="local-retail__numeric">
      <span class="prepend">$</span>
        <input
          v-model="value"
          class="numeric-input"
          min="0"
          max="100"
          maxlength="4"
          placeholder="0.00"
          step="0.01"
          type="number"
          @blur="handleBlur"
        />
      <small> / {{ unit }} </small>
    </div>
  </div>
</template>
<script>
import AppHeading from '@/components/shared/AppHeading';

export default {
  components: {
    AppHeading
  },
  props: {
    modelValue: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: this.modelValue || ''
    };
  },
  emits: ['update:modelValue'],
  methods: {
    handleBlur(event) {
      this.value = parseFloat(this.value).toFixed(2);
      this.$emit('update:modelValue', this.value);
    }
  }
};
</script>

<style lang="scss">
.local-retail {
  margin: spacing('xl') 0;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    display: none !important; /* stylelint-disable-line declaration-no-important */
  }

  &__numeric {
    @include font('trade-gothic', 'bold');
    font-size: 2.5rem;

    ::placeholder {
      color: color('black');
      opacity: 1;
    }

    small {
      color: color('black');
      font-size: 22px;
      left: -9px;
      position: relative;
      text-transform: uppercase;
    }
  }
  .prepend {
    color: color('black');
    font-size: 2.125rem;
    left: -15px;
    position: relative;
  }

  input.numeric-input {
    font-family: $articulat-cf;
    font-weight: 400;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    color: color('black');
    font-size: 2.125rem;
    left: -10px;
    max-height: 36px;
    position: relative;
    width: 130px;
    ::placeholder {
      color: #000;
    }

    &:focus::placeholder {
      color: transparent;
    }
  }
}
</style>
